export enum STATUS {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  NEW = 'NEW',
  DRAFT = 'DRAFT',
  SUBMITTED = 'SUBMITTED',
  CONFIRMED = 'CONFIRMED',
  PENDING = 'PENDING',
  VERIFIED = 'VERIFIED',
  APPROVED = 'APPROVED',
  REVIEWING = 'REVIEWING',
  REJECTED = 'REJECTED',
  RETURNED = 'RETURNED',
  ALLOCATE = 'ALLOCATE',
  ASSIGN = 'ASSIGN',
  TERMINATE = 'TERMINATE',
  SUSPENDED = 'SUSPENDED',
  REOPENED = 'REOPENED',
  CLOSED = 'CLOSED',
  DENIED = 'DENIED',
  PAID = 'PAID',
  CREATED = 'CREATED',
  DELETED = 'DELETED',
  ACCEPTED = 'ACCEPTED',
  VERIFYING = 'VERIFYING',
  CHECKED = 'CHECKED',
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',

  INPROGRESS = 'INPROGRESS',

  NON_CONTRACT = 'NON_CONTRACT',

  EXPIRE_SOON = 'EXPIRE_SOON',
  EXPIRED = 'EXPIRED',

  HC_SUBMITTED = 'HC_SUBMITTED',
  HC_RETURNED = 'HC_RETURNED',
  HC_REJECTED = 'HC_REJECTED',
  HC_ACCEPTED = 'HC_ACCEPTED',
  BEN_HC_RETURNED = 'BEN_HC_RETURNED',

  CASE_DELETED = 'CASE_DELETED',

  RESUBMIT = 'RESUBMIT',
  NSSF_COMPLETED = 'NSSF_COMPLETED',
  NSSF_ASSIGN = 'NSSF_ASSIGN',
  NSSF_VERIFIED = 'NSSF_VERIFIED',
  NSSF_REJECTED = 'NSSF_REJECTED',
  NSSF_RETURNED = 'NSSF_RETURNED',
  NSSF_CLEARED = 'NSSF_CLEARED',

  CONTINUE_PAYMENT = 'NSSF_CONTINUE_PAYMENT',

  NSSF_SKIPPED = 'NSSF_SKIPPED',
  NSSF_DELETE = 'NSSF_DELETE',

  MARK_COMPLETED = 'MARK_COMPLETED',

  EMPTY = 'EMPTY',
}
